export const setSelectedAssets = (asset) => ({
  type: "SET_SELECTED_ASSET",
  payload: asset,
});

export const setTagInfo = (tagInfo) => ({
  type: "SET_TAG_INFO",
  payload: tagInfo,
});